import type { AppModule } from '@/core/types';

import { accountRoute, loginRoute, magicLinkRoute } from './routes';

export const AuthModule: AppModule = {
  routes: { loginRoute, magicLinkRoute, accountRoute },
};
